// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SpinnerOverlay_wrapper__Vaq0A","header":"SpinnerOverlay_header__ZUWrS","subheader":"SpinnerOverlay_subheader__epjVz","pulse":"SpinnerOverlay_pulse___t0Mz"};